import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

import {
  GOOGLE_PAY_MARK_OFFSET,
  GOOGLE_PAY_MARK_SIZE,
  GOOGLE_PAY_MARK_WIDTH,
  Text,
  tokens,
} from '@fhs/ui';

interface IPaymentEntryProps {
  icon: React.ReactNode;
  text?: string | React.ReactNode;
  textReplacement?: React.ReactNode;
  selected: boolean;
  onPress: () => void;
  testID?: string;
  hideIconCircle?: boolean;
}

export default function PaymentEntry({
  icon,
  text,
  textReplacement,
  selected,
  onPress,
  testID,
  hideIconCircle = false,
}: IPaymentEntryProps) {
  return (
    <Pressable testID={testID} style={styles.row} onPress={onPress}>
      <View style={styles.innerRow}>
        <View style={hideIconCircle ? styles.iconSlot : styles.iconCircle}>{icon}</View>
        {text ? (
          <Text.Ui weight="semibold" size="lg">
            {text}
          </Text.Ui>
        ) : (
          textReplacement
        )}
      </View>

      {selected ? <View style={styles.radioSelected} /> : <View style={styles.radioUnselected} />}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  row: {
    borderBottomColor: tokens.colors.$black10,
    borderBottomWidth: 1,
    width: '100%',
    height: 64,
    paddingHorizontal: 32,
    paddingVertical: 12,
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },

  innerRow: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },

  iconSlot: {
    height: GOOGLE_PAY_MARK_SIZE,
    width: GOOGLE_PAY_MARK_WIDTH,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: GOOGLE_PAY_MARK_OFFSET,
    marginRight: 12 + GOOGLE_PAY_MARK_OFFSET,
  },

  iconCircle: {
    height: 40,
    width: 40,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.$houseLight,
    marginRight: 12,
  },

  radioSelected: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 5,
    borderColor: tokens.colors.$houseRed,
    alignItems: 'center',
    justifyContent: 'center',
  },

  radioUnselected: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity30,
  },
});
